export default __webpack_public_path__ + "static/media/rightUsersProfile.3c2caf4b.svg";